import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  STRING_getInstance7xungxdjbzv as STRING_getInstance,
  BOOLEAN_getInstancewc2j8mltq0p1 as BOOLEAN_getInstance,
  DOUBLE_getInstance26ldxisjb14a2 as DOUBLE_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { ExcelFormula1nf87837hifx4 as ExcelFormula } from './excel/Excel.mjs';
import { toExcelValues1jab7k1silffo as toExcelValues } from './excel/ExcelSerialization.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  Bool1r3p37fvso3wz as Bool,
  Number6kmrfn4klz39 as Number_0,
} from './excel/ExcelValue.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _ExcelLikeFormula___init__impl__5newgn(string) {
  return string;
}
function _ExcelLikeFormula___get_string__impl__klk7ep($this) {
  return $this;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.ZERO_1 = _ExcelLikeFormula___init__impl__5newgn('0.0');
        this.TRUE_1 = _ExcelLikeFormula___init__impl__5newgn('TRUE()');
      }
      serializer_vc198b_k$(typeSerial0, typeSerial1) {
        return new (ExcelLikeFormulaSerializer())(typeSerial0, typeSerial1);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_vc198b_k$(typeParamsSerializers[0], typeParamsSerializers[1]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function ExcelLikeFormula__toString_impl_rnbgi1($this) {
  return 'ExcelLikeFormula(string=' + $this + ')';
}
function ExcelLikeFormula__hashCode_impl_5w5jp6($this) {
  return getStringHashCode($this);
}
function ExcelLikeFormula__equals_impl_hwq2mu($this, other) {
  if (!(other instanceof ExcelLikeFormula()))
    return false;
  if (!($this === other.string_1))
    return false;
  return true;
}
var ExcelLikeFormulaClass;
function ExcelLikeFormula() {
  if (ExcelLikeFormulaClass === VOID) {
    class $ {
      constructor(string) {
        Companion_getInstance();
        this.string_1 = string;
      }
      toString() {
        return ExcelLikeFormula__toString_impl_rnbgi1(this.string_1);
      }
      hashCode() {
        return ExcelLikeFormula__hashCode_impl_5w5jp6(this.string_1);
      }
      equals(other) {
        return ExcelLikeFormula__equals_impl_hwq2mu(this.string_1, other);
      }
    }
    initMetadataForClass($, 'ExcelLikeFormula', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    ExcelLikeFormulaClass = $;
  }
  return ExcelLikeFormulaClass;
}
var ExcelLikeFormulaSerializerClass;
function ExcelLikeFormulaSerializer() {
  if (ExcelLikeFormulaSerializerClass === VOID) {
    class $ {
      constructor(input, output) {
        this.input_1 = input;
        this.output_1 = output;
        this.descriptor_1 = PrimitiveSerialDescriptor('org.thecommunitygroupinc.cares.ExcelLikeFormula', STRING_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_7wyh7f_k$(encoder, value) {
        return encoder.encodeString_424b5v_k$(_ExcelLikeFormula___get_string__impl__klk7ep(value));
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_7wyh7f_k$(encoder, value instanceof ExcelLikeFormula() ? value.string_1 : THROW_CCE());
      }
      deserialize_jkkp22_k$(decoder) {
        return _ExcelLikeFormula___init__impl__5newgn(decoder.decodeString_x3hxsx_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ExcelLikeFormula())(this.deserialize_jkkp22_k$(decoder));
      }
    }
    initMetadataForClass($, 'ExcelLikeFormulaSerializer', VOID, VOID, [KSerializer()]);
    ExcelLikeFormulaSerializerClass = $;
  }
  return ExcelLikeFormulaSerializerClass;
}
function evaluate(_this__u8e3s4, input, inputSerializer, outputSerializer) {
  var formula = new (ExcelFormula())(_ExcelLikeFormula___get_string__impl__klk7ep(_this__u8e3s4));
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = toExcelValues(inputSerializer, input).get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.next_20eer_k$();
    // Inline function 'kotlin.collections.component1' call
    var k = _destruct__k2r9zo.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var v = _destruct__k2r9zo.get_value_j01efc_k$();
    formula.withValue_fbg6h3_k$(k, v);
  }
  var result = formula.eval_1uzks_k$();
  var tmp0_safe_receiver = result.userError_57tibh_k$();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw ExcelEvaluationException().new_org_thecommunitygroupinc_cares_ExcelEvaluationException_otndrn_k$(tmp0_safe_receiver);
  }
  var tmp1_subject = outputSerializer.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$();
  var tmp;
  if (equals(tmp1_subject, DOUBLE_getInstance())) {
    var tmp2_safe_receiver = result instanceof Number_0() ? result : null;
    tmp = to(tmp2_safe_receiver == null ? null : tmp2_safe_receiver.value_1, 'a number');
  } else if (equals(tmp1_subject, BOOLEAN_getInstance())) {
    var tmp3_safe_receiver = result instanceof Bool() ? result : null;
    tmp = to(tmp3_safe_receiver == null ? null : tmp3_safe_receiver.value_1, 'true or false');
  } else {
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Formulas produce Double or Boolean, not ' + outputSerializer.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() + '.');
  }
  var _destruct__k2r9zo_0 = tmp;
  var value = _destruct__k2r9zo_0.component1_7eebsc_k$();
  var expected = _destruct__k2r9zo_0.component2_7eebsb_k$();
  var tmp_0;
  if (value == null) {
    throw ExcelEvaluationException().new_org_thecommunitygroupinc_cares_ExcelEvaluationException_otndrn_k$("It produced '" + result.display_rnbphe_k$() + "', which did not evaluate to " + expected + '.');
  } else {
    tmp_0 = value;
  }
  return tmp_0;
}
var ExcelEvaluationExceptionClass;
function ExcelEvaluationException() {
  if (ExcelEvaluationExceptionClass === VOID) {
    class $ extends Exception() {
      constructor(message) {
        return new.target.new_org_thecommunitygroupinc_cares_ExcelEvaluationException_otndrn_k$(message);
      }
      static new_org_thecommunitygroupinc_cares_ExcelEvaluationException_otndrn_k$(message) {
        var $this = this.new_kotlin_Exception_hsqbop_k$(message);
        captureStack($this, $this.$throwableCtor_2);
        return $this;
      }
    }
    initMetadataForClass($, 'ExcelEvaluationException');
    ExcelEvaluationExceptionClass = $;
  }
  return ExcelEvaluationExceptionClass;
}
//region block: exports
export {
  _ExcelLikeFormula___init__impl__5newgn as _ExcelLikeFormula___init__impl__5newgny7l2ajw10exm,
  ExcelLikeFormula__hashCode_impl_5w5jp6 as ExcelLikeFormula__hashCode_impl_5w5jp6fcwlwnsu3lo4,
  _ExcelLikeFormula___get_string__impl__klk7ep as _ExcelLikeFormula___get_string__impl__klk7ep2db4efrd7vvyv,
  ExcelLikeFormula__toString_impl_rnbgi1 as ExcelLikeFormula__toString_impl_rnbgi1zeuj2qebb9le,
  Companion_getInstance as Companion_getInstance3o354p9o0zadk,
  ExcelEvaluationException as ExcelEvaluationException1vr3sbgdrxa1l,
  ExcelLikeFormula as ExcelLikeFormula3nl4zwq7og62,
  evaluate as evaluate15etsj5qcr9at,
};
//endregion

//# sourceMappingURL=excel.mjs.map
